import React, { useState, useEffect, useContext } from 'react'
import { getApiTargetInfo } from 'core'

import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import { wind2PlantSelection, getSystemConfigurationInfo } from 'api/pgads'
import { DataContext, ErrorContext } from 'context'
import { getwind2MissingData } from './wind2api'
import { Button, DatePicker, Input, message, Modal, Select } from 'antd'
import moment from 'moment'
import { dateCol, strCol } from '@integec/grid-tools/lib/cols'
import R from 'ramda'

export const WindMissingDataHeaders = [
  strCol({
    ident: 'frequency',
    display: 'Frequency',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  dateCol({
    ident: 'transDate',
    display: 'TransDate',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'missingInterval',
    display: 'Missing Interval',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'tags',
    display: 'Tags',
    isFiltered: true,
    width: 1000,
    alignment: 'left',
    ellipsis: true,
  }),
]
const title = 'Wind PI Missing Data'

const Wind2MissingData = ({ apiTargetInfo }) => {
  const [plants, setPlants] = useState([])
  const [selectedDateRangePicker, setSelectedDateRagePicker] = useState([
    moment(),
    moment(),
  ])
  const {
    selectedWind2Plant,
    setSelectedWind2Plant: setSelectedPlant,
  } = useContext(DataContext)
  const selectedPlant = Array.isArray(selectedWind2Plant)
    ? selectedWind2Plant[0]
    : selectedWind2Plant
  const [windMissingDataDaysGap, setwindMissingDataDaysGap] = useState()

  const { setError } = useContext(ErrorContext)

  useEffect(
    _ => {
      wind2PlantSelection(apiTargetInfo)({
        year: selectedDateRangePicker[1].format('YYYY'),
        month: selectedDateRangePicker[1].format('MM'),
      }).fork(setError, data => {
        const sd = R.sortBy(R.prop('plantName'), data)
        setPlants(sd)
        if (!selectedPlant && sd[0] && sd[0].plantId)
          setSelectedPlant([sd[0].plantId])
      })

      getSystemConfigurationInfo(apiTargetInfo).fork(setError, d => {
        const dateRange = d.find(
          s => s.key === 'WIND2_MISSING_DATA_DAYS_LIMIT'
        ) || { value: 31 }
        setwindMissingDataDaysGap(dateRange.value)
      })
    },
    [
      apiTargetInfo,
      selectedDateRangePicker,
      selectedPlant,
      setError,
      setSelectedPlant,
    ]
  )
  const beforeRetrieveValidation = () => {
    if (!selectedPlant) {
      message.warning('Please, Select a Plant')
      return false
    }
    const startDate = selectedDateRangePicker[0]
    const endDate = selectedDateRangePicker[1]

    const isValid =
      endDate.diff(startDate, 'days') <= parseInt(windMissingDataDaysGap)
    if (!isValid) {
      message.error(
        'Selected date range should be within ' +
          windMissingDataDaysGap +
          ' days.'
      )
    }
    return isValid
  }

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <div>
        <Select
          showSearch
          style={{ width: '350px' }}
          placeholder="Select Plant"
          onChange={value => setSelectedPlant([value])}
          value={selectedPlant}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {R.sortBy(R.prop('plantName'))(plants).map(item => (
            <Select.Option key={item.plantId} value={item.plantId}>
              {item.plantName}
            </Select.Option>
          ))}
        </Select>
        <DatePicker.RangePicker
          style={{ marginLeft: '10px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDateRangePicker}
          onChange={d => {
            setSelectedDateRagePicker(d)
            onChange()
          }}
        />
      </div>
    )
  }

  const [showDetails, setShowDetails] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')

  const extraCriteriaAfterButton = ({ selectedRows }) => {
    const tagList = selectedRows?.selectedRows[0]?.tags
      .split(',')
      .filter(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()))
    return (
      <div>
        <Modal
          title="Deatil Data"
          width="80vw"
          visible={showDetails}
          // open={showDetails}
          footer={[
            <Button key="cancle" onClick={() => setShowDetails(false)}>
              Cancel
            </Button>,
          ]}
          onCancel={() => setShowDetails(false)}
          destroyOnClose
          closable
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '10px 7px',
            }}
          >
            <div>
              <span style={{ display: 'block', marginBottom: '5px' }}>
                Frequency
              </span>
              <Input
                value={selectedRows?.selectedRows[0]?.frequency}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <span style={{ display: 'block', marginBottom: '5px' }}>
                TransDate
              </span>
              <Input
                value={selectedRows?.selectedRows[0]?.transDate}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <span style={{ display: 'block', marginBottom: '5px' }}>
                Missing Interval
              </span>
              <Input
                value={selectedRows?.selectedRows[0]?.missingInterval}
                style={{ width: '100%' }}
              />
            </div>
            <div style={{ gridColumn: 'span 3' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '10px',
                }}
              >
                <span style={{ marginRight: '10px' }}>Tags:</span>
                <input
                  type="text"
                  placeholder="Search tags..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                  style={{
                    flex: '1',
                    maxWidth: '400px',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                  }}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-start',
                  alignContent: 'flex-start',
                  maxHeight: '45vh',
                  height: '45vh',
                  overflow: 'auto',
                  border: '1px solid #eee',
                  borderRadius: '5px',
                  paddingTop: '10px',
                  paddingBottom: '0px',
                  // gap: '10px',
                }}
              >
                {tagList?.map((tag, index) => (
                  <div
                    key={tag + index}
                    style={{
                      // height: '30px',
                      overflow: 'wrap',
                      flex: '0 0 80px',
                      width: 'max-content',
                      paddingTop: '5px',
                      paddingLeft: '10px',
                    }}
                  >
                    <p>{tag}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Modal>
        <Button
          onClick={() => setShowDetails(true)}
          type="primary"
          disabled={
            selectedRows?.selectedRows &&
            selectedRows?.selectedRows?.length <= 0
          }
          // style={{ marginLeft: '10px' }}
        >
          Show Details
        </Button>
      </div>
    )
  }

  return (
    <CommonScreen
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      title={title}
      header={WindMissingDataHeaders}
      retrieveTask={getwind2MissingData}
      withCriteria={_ => ({
        start: selectedDateRangePicker[0],
        end: selectedDateRangePicker[1],
        plant: selectedPlant,
      })}
      beforeRetrieveValidation={beforeRetrieveValidation}
      screenCriteria={screenCriteria}
      sortOptions={WindMissingDataHeaders}
      allowInsert={false}
      isEditableGrid={_ => false}
      isAdminScreen={false}
      withoutModify
      widthOffset={50}
      autoFixColByKey={false}
      headerRowHeight={30}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Wind2MissingData)
